// extracted by mini-css-extract-plugin
export default {"news__pagination":"NewsPagination_news__pagination__bHKTy","news__button":"NewsPagination_news__button__GPn0C","news__button-active":"NewsPagination_news__button-active__bTszU"};